import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { generatePath, useNavigate } from 'react-router-dom';

import { Messages as MessagesComponent } from 'us-react-components/dist/Messages/Messages';
import { AxiosRequestConfig, MessageThreadService } from 'us-web-services';
import { useDependencies } from '../../../dependencies';
import { Routes } from '../../../Routes';

const Messages = observer((): JSX.Element => {
  const {
    services: { tracker },
    stores,
  } = useDependencies();
  const navigate = useNavigate();
  const { user } = stores.user;
  const id = user.id?.toString() ?? '';
  const [unreadMessages, setUnreadMessages] = useState<number>(0);

  useEffect(() => {
    if (!id) return;

    const params = {
      userId: id,
      parentId: id,
      read: false,
      limit: 1,
    };

    const config: AxiosRequestConfig = {
      params,
    };

    MessageThreadService.getByFilter(config).then(response => {
      setUnreadMessages(response.data.meta.size ?? 0);
    });
  }, []);

  const handleClick = (): void => {
    navigate(generatePath(Routes.parent.messages, { id }));
    tracker.track('clicked-button', { elementText: 'header-messages' });
  };

  return (
    <MessagesComponent
      unreadMessagesCount={unreadMessages}
      handleClick={handleClick}
    />
  );
});

export default Messages;
